import React from "react";
import { configContext } from "./context.js";
const ConfigProvider = ({ context, config, children }) => /* @__PURE__ */ React.createElement(
  configContext.Provider,
  {
    value: {
      config,
      context
    }
  },
  children
);
export {
  ConfigProvider
};
//# sourceMappingURL=provider.js.map
